<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="6">
        <div class="text-h5 font-weight-regular">
          Thông Tin Nông Nghiệp
        </div>
      </v-col>
      <v-col cols="6">
        <div class="text-right">
          <v-btn text to="/news">
            <span class="primary--text">Xem thêm ❯❯</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="news.length > 0" 
      class="mt-2" 
      justify="center"
    >
      <v-col 
        cols="12" 
        md="3" 
        v-for="(item,index) in news"
        :key="index"
      >
        <v-sheet height="100%" class="rounded-lg overflow-hidden">
          <v-hover
            v-slot="{ hover }"
          >
            <v-card class="mx-auto" flat>
              <router-link
                :to="{ name: 'NewsView', params: { id: item.id }}"
              >
                <div 
                  v-if="item.muc_do && item.muc_do != 'NORMAL'" 
                  class="ribbon ribbon-top-right"
                  :class="[item.muc_do == 'WARNING' ? 'color-warning' : (item.muc_do == 'DANGER' ? 'color-danger' : 'color-success')]"
                >
                  <span v-if="item.muc_do == 'WARNING'">Nguy cơ</span>
                  <span v-else-if="item.muc_do == 'DANGER'">Khẩn cấp</span>
                  <span v-else>Dự báo</span>
                </div>
                <v-img
                  :src="item.anh_dai_dien ? `${apiBaseUrl}/uploads/${item.anh_dai_dien}` : require(`@/assets/news-default-thumb.jpeg`)"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="230px"
                  class="white--text align-end"
                  :style="{opacity: hover ? '0.9' : 1}"
                >
                  <v-card-text>
                    <div class="yellow--text text-subtitle-2">
                      {{item.category.dien_giai}}
                    </div>
                    <p class="font-italic">
                      {{item.published_at}}
                    </p>
                  </v-card-text>
                </v-img>
              </router-link>
              <v-card-text class="text--primary">
                <div 
                  class="news-title text-body-2" 
                  :title="item.tieu_de"
                >
                  {{item.tieu_de}}
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row v-else class="mt-8">
      <v-col
        v-for="i in 4"
        :key="i"
        cols="6"
        md="3"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="image, list-item-two-line"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'News',
  data () {
    return {
      loadingNews: false,
      news: []
    }
  },
  computed: {
    ...mapState([ 
      'config'
    ]),
    apiBaseUrl() {
      return this.config.beUrl;
    }
  },
  mounted () {
    this.getNews();
  },
  methods: {
    getNews () {
      this.loadingNews=true;
      let request = {
        params: {
          size: 4,
          page: 1
        }
      };
      axios.get("api/v1/public/news", request)
        .then(response => {
          this.news = response.data.data;
          this.loadingNews=false;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>
<style>
  .ribbon {
    width: 150px;
    height: 150px;
    overflow: hidden;
    position: absolute;
    z-index: 1;
  }
  .ribbon::before,
  .ribbon::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid #F9A825;
  }
  .ribbon span {
    position: absolute;
    display: block;
    width: 225px;
    padding: 7px 0;
    box-shadow: 0 2px 1px rgba(0,0,0,.1);
    color: #fff;
    font: 500 16px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0,0,0,.2);
    text-transform: uppercase;
    text-align: center;
  }
  .color-warning span{
    background-color: #F9A825;
  }
  .color-danger span{
    background-color: #ff5252;
  }
  .color-success span{
    background-color: green;
  }
  .ribbon-top-right {
    top: -10px;
    right: -10px;
  }
  .ribbon-top-right::before,
  .ribbon-top-right::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  .ribbon-top-right::before {
    top: 0;
    left: 22px;
  }
  .ribbon-top-right::after {
    bottom: 22px;
    right: 0;
  }
  .ribbon-top-right span {
    left: -27px;
    top: 29px;
    transform: rotate(45deg);
  }
  .v-card__text .news-title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2; 
    -webkit-box-orient: vertical;
  }
</style>
